import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Switch from '@material-ui/core/Switch';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';

class EditNode extends React.Component {
    state = {
        evitarCron: this.props.node ? this.props.node.evitarCron : false,
        nombre: this.props.node ? this.props.node.nombre : '',
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleChecked = (event) => {
        this.setState({ [event.target.name]: event.target.checked });
    };

    handleClose = (nombre, evitarCron) => (event) => {
        if (nombre === null) {
            this.props.handleClose(undefined);
        } else {
            this.props.node.nombre = nombre;
            this.props.node.evitarCron = evitarCron;
            this.props.handleClose(this.props.node);
        }
    };

    render() {
        const { evitarCron, nombre } = this.state;
        const { intl } = this.props;
        return (
            <Dialog
                open={true}
                onClose={this.handleClose(null, null)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent className={'padding_borders'}>
                    <div className="flex_full_row margin_top_18 align_center">
                        <TextField
                            fullWidth
                            id={'nombre'}
                            name={'nombre'}
                            label={intl.formatMessage({
                                id: 'form_field_name_nombre',
                            })}
                            className={'flex_full_row'}
                            value={nombre}
                            onChange={this.handleChange}
                            margin="normal"
                        />
                    </div>
                    <div className="flex_full_row margin_top_32 align_center">
                        <div className="flex_full_column">
                            <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                <FormattedMessage id="form_field_name_avoid_cron" />
                            </div>
                        </div>
                        <div className="flex_auto_column">
                            <Switch
                                name={'evitarCron'}
                                checked={evitarCron}
                                onChange={this.handleChecked}
                                value="active"
                                color="primary"
                            />
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose(null, null)} color="primary">
                        <FormattedMessage id="cancel" />
                    </Button>
                    <Button
                        onClick={this.handleClose(nombre, evitarCron)}
                        color="primary"
                        autoFocus
                    >
                        <FormattedMessage id="accept" />
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

EditNode.propTypes = {
    intl: intlShape.isRequired,
    info: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        info: state.info,
    };
};

EditNode = connect(
    mapStateToProps,
    null,
)(EditNode);

EditNode = injectIntl(EditNode);

export default EditNode;



// WEBPACK FOOTER //
// ./src/components/complex/manage/customer/EditNode.js